var render = function render(_c, _vm) {
  return _c("div", {
    staticClass: "pack-hero",
    style: `
    background-clip: padding-box;
    background-color: var(--theme-hero-background);
    background-image: url('/images/icons/packs/${_vm.parent.iconPack().name}/${
      _vm.parent.iconPack().heroImage
    }');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: var(--icon-pack-hero-min-height, 20vw);
  `,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }